import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../_theme/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_cd6db766 from 'nuxt_plugin_plugin_cd6db766' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtplugin52a776db_118955dd from 'nuxt_plugin_nuxtplugin52a776db_118955dd' // Source: ./nuxt.plugin.52a776db.js (mode: 'server')
import nuxt_plugin_vuescrollto_3718d7ee from 'nuxt_plugin_vuescrollto_3718d7ee' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_041dc13a from 'nuxt_plugin_cookieuniversalnuxt_041dc13a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_6c823440 from 'nuxt_plugin_pluginutils_6c823440' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_48825d98 from 'nuxt_plugin_pluginseo_48825d98' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_0b9d7b2b from 'nuxt_plugin_pluginrouting_0b9d7b2b' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_57aa3824 from 'nuxt_plugin_pluginmain_57aa3824' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_79a5615e from 'nuxt_plugin_gtm_79a5615e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtplugin9d3d6752_f840b65a from 'nuxt_plugin_nuxtplugin9d3d6752_f840b65a' // Source: ./nuxt.plugin.9d3d6752.js (mode: 'all')
import nuxt_plugin_pluginsi18ncookies3443bb16_bd7c3368 from 'nuxt_plugin_pluginsi18ncookies3443bb16_bd7c3368' // Source: ./plugins.i18n-cookies.3443bb16.js (mode: 'all')
import nuxt_plugin_pluginse2etesting9c9e21c4_3d95bf54 from 'nuxt_plugin_pluginse2etesting9c9e21c4_3d95bf54' // Source: ./plugins.e2e-testing.9c9e21c4.js (mode: 'all')
import nuxt_plugin_pluginsloggera8fae176_30aea1c4 from 'nuxt_plugin_pluginsloggera8fae176_30aea1c4' // Source: ./plugins.logger.a8fae176.js (mode: 'all')
import nuxt_plugin_pluginsssr17515af2_a419ec8e from 'nuxt_plugin_pluginsssr17515af2_a419ec8e' // Source: ./plugins.ssr.17515af2.js (mode: 'all')
import nuxt_plugin_pluginscontext94f1ce6c_c8e92c4a from 'nuxt_plugin_pluginscontext94f1ce6c_c8e92c4a' // Source: ./plugins.context.94f1ce6c.js (mode: 'all')
import nuxt_plugin_distplugin751bbfbe_6f2b14cb from 'nuxt_plugin_distplugin751bbfbe_6f2b14cb' // Source: ./dist.plugin.751bbfbe.mjs (mode: 'all')
import nuxt_plugin_loadconfig_cef778c4 from 'nuxt_plugin_loadconfig_cef778c4' // Source: ../plugins/loadconfig (mode: 'all')
import nuxt_plugin_piniapluginpersist_06683d2e from 'nuxt_plugin_piniapluginpersist_06683d2e' // Source: ../plugins/pinia-plugin-persist.client (mode: 'client')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_i18n_258c69cb from 'nuxt_plugin_i18n_258c69cb' // Source: ../plugins/i18n.interceptor (mode: 'all')
import nuxt_plugin_moments_306ff23d from 'nuxt_plugin_moments_306ff23d' // Source: ../plugins/moments (mode: 'all')
import nuxt_plugin_meta_3bd7ae9f from 'nuxt_plugin_meta_3bd7ae9f' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"xbuy store","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Raleway:300,400,400i,500,600,700|Roboto:300,300i,400,400i,500,700&display=swap"},{"name":"generator","content":"Vue Storefront 2"}],"link":[],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_cd6db766 === 'function') {
    await nuxt_plugin_plugin_cd6db766(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin52a776db_118955dd === 'function') {
    await nuxt_plugin_nuxtplugin52a776db_118955dd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_3718d7ee === 'function') {
    await nuxt_plugin_vuescrollto_3718d7ee(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_041dc13a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_041dc13a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6c823440 === 'function') {
    await nuxt_plugin_pluginutils_6c823440(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_48825d98 === 'function') {
    await nuxt_plugin_pluginseo_48825d98(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_0b9d7b2b === 'function') {
    await nuxt_plugin_pluginrouting_0b9d7b2b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_57aa3824 === 'function') {
    await nuxt_plugin_pluginmain_57aa3824(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_79a5615e === 'function') {
    await nuxt_plugin_gtm_79a5615e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin9d3d6752_f840b65a === 'function') {
    await nuxt_plugin_nuxtplugin9d3d6752_f840b65a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18ncookies3443bb16_bd7c3368 === 'function') {
    await nuxt_plugin_pluginsi18ncookies3443bb16_bd7c3368(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting9c9e21c4_3d95bf54 === 'function') {
    await nuxt_plugin_pluginse2etesting9c9e21c4_3d95bf54(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsloggera8fae176_30aea1c4 === 'function') {
    await nuxt_plugin_pluginsloggera8fae176_30aea1c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssr17515af2_a419ec8e === 'function') {
    await nuxt_plugin_pluginsssr17515af2_a419ec8e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext94f1ce6c_c8e92c4a === 'function') {
    await nuxt_plugin_pluginscontext94f1ce6c_c8e92c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin751bbfbe_6f2b14cb === 'function') {
    await nuxt_plugin_distplugin751bbfbe_6f2b14cb(app.context, inject)
  }

  if (typeof nuxt_plugin_loadconfig_cef778c4 === 'function') {
    await nuxt_plugin_loadconfig_cef778c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_piniapluginpersist_06683d2e === 'function') {
    await nuxt_plugin_piniapluginpersist_06683d2e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_258c69cb === 'function') {
    await nuxt_plugin_i18n_258c69cb(app.context, inject)
  }

  if (typeof nuxt_plugin_moments_306ff23d === 'function') {
    await nuxt_plugin_moments_306ff23d(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_3bd7ae9f === 'function') {
    await nuxt_plugin_meta_3bd7ae9f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
